import throttle from 'lodash/throttle'
import { createAPI } from 'gyl-common/utils/createAPI'
import { getSingle } from 'gyl-common/utils/singleton'
import ProcessModal from '../../components/ProcessModal'
import Downloader from '../../core/downloader'

const lazy = throttle(fn => fn(), 300)

export const createManager = () => {
    let processor: any = null
    let downloader: any = null
    let setFiles: any = () => {}

    const getProcessor = () => {
        if (!processor) {
            const modal = createAPI(ProcessModal, {
                files: [],
                onRef(e: any) {
                    setFiles = e.setFiles
                },
                onDownloadCancel() {
                    modal.close()

                    setTimeout(() => {
                        downloader.clear()
                        processor = null
                        downloader = null
                    }, 200)
                }
            })

            processor = modal
        }

        return processor
    }

    const getDownloader = (config: any) => {
        if (!downloader) {
            downloader = new Downloader({
                ...config,
                onChange(e: any) {
                    lazy(() => {
                        setFiles && setFiles(e)
                    })
                }
            })
        } else {
            config && downloader.setOptions(config)
        }

        return downloader
    }

    return {
        getDownloader,
        getProcessor
    }
}

export const getManager = getSingle(createManager)
